import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { isExternalUrl, isJavascriptLink } from 'js/utils/url.util';

export const useIsAllowedToRedirect = () => {
    const allowedRedirectHostNames = useAppSelector(prop('allowedRedirectHostNames'));

    return useCallback((path) => {
        if (isJavascriptLink(path)) {
            return false;
        }

        if (!allowedRedirectHostNames || !isExternalUrl(path)) {
            return true;
        }

        const hosts = allowedRedirectHostNames
            .split(',')
            .map(host => host.trim())
            .filter(Boolean);

        if (!hosts.length) {
            return true;
        }

        try {
            const url = new URL(path);

            return url.hostname === window.location.hostname || hosts.includes(url.hostname);
        } catch {
            return false;
        }
    }, [allowedRedirectHostNames]);
};
